import { EventActivityFeed } from '@/components/activity/EventActivityFeed';
import { ConnectionBadge } from '@/components/events/live';
import { useDisplaySocket } from '@/hooks/useDisplaySocket';
import { useEventContext } from '@/pages/events/useEventContext';

/**
 * Admin activity feed tab: the shared event feed with a live socket
 * connection badge (socket invalidation + 10s polling fallback both live
 * inside EventActivityFeed/useDisplaySocket).
 */
export function EventActivityTab() {
  const { event } = useEventContext();
  const { status } = useDisplaySocket(event?.id);

  return (
    <EventActivityFeed
      eventId={event?.id}
      title="Activity Feed"
      headerRight={<ConnectionBadge status={status} />}
    />
  );
}
